module.exports = __webpack_public_path__ + "img/logo.78fc8710.svg";